import i18n from 'i18next';
import { setLocale } from 'yup';

setLocale({
  mixed: {
    required: i18n.t('form:errors.required'),
  },
});
